<template>
   <div id="app" class="h-100" style="overflow-x: hidden" ref="appComponent">
      <component :is="layout" :dataLoading="dataLoading" :pageLoading="pageLoading">
         <transition name="fade-fast" mode="out-in">
            <router-view
               @showSpinner="(val) => (dataLoading = val)"
               @showPageload="(val) => (pageLoading = val)"
            >
            </router-view>
         </transition>
      </component>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   data() {
      return {
         dataLoading: false,
         pageLoading: false,
      };
   },

   computed: {
      ...mapGetters({
         isClient: 'isClient',
         isRndig: 'isRndig',
         isExternalPartner: 'isExternalPartner',
         globalDataLoading: 'dataLoading',
      }),

      layout() {
         if (this.$route.meta.layout) {
            return this.$route.meta.layout;
         }
         if (this.isClient) {
            return 'CustomerLayout';
         } else if (this.isRndig || this.isExternalPartner) {
            return 'RdigLayout';
         } else {
            return 'EmptyLayout';
         }
      },
   },

   mounted() {
      this.$store.dispatch('setAppComponentRef', this.$refs.appComponent);
   },

   watch: {
      globalDataLoading(newValue) {
         this.dataLoading = newValue;
      },
   },
};
</script>
